import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { HERO_IMAGE, BILLING } from "@/lib/data";

export default function Hero() {
    return (
        <section
            id="top"
            data-testid="hero-section"
            className="relative min-h-[100svh] pt-28 pb-20 md:pt-32 md:pb-24"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-12 gap-6 md:gap-10 items-end">
                {/* Headline column */}
                <div className="col-span-12 md:col-span-6 md:order-1 order-2">
                    <motion.p
                        initial={{ opacity: 0, y: 12 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7 }}
                        className="eyebrow mb-6"
                    >
                        {BILLING.union} · Actor & Director
                    </motion.p>

                    <motion.h1
                        initial={{ opacity: 0, y: 24 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.9, delay: 0.1 }}
                        data-testid="hero-name"
                        className="font-serif-display text-[15vw] sm:text-7xl md:text-[7.5rem] lg:text-[9rem] leading-[0.9] tracking-tight text-[#1A1A1A]"
                    >
                        Vickie
                        <br />
                        <span className="italic font-light">Daignault</span>
                    </motion.h1>

                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.9, delay: 0.4 }}
                        className="mt-8 md:mt-12 max-w-md"
                    >
                        <p className="font-serif-display italic text-2xl md:text-3xl text-[#4A4A4A] leading-snug">
                            I play women with:
                            <br />
                            Commanding presence
                            <br />
                            Dangerous humor
                            <br />
                            Questionable judgement
                        </p>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.9, delay: 0.6 }}
                        className="mt-10 md:mt-14 grid grid-cols-2 gap-y-4 gap-x-8 max-w-md border-t border-[#D1CFC9] pt-6"
                    >
                        <div>
                            <div className="eyebrow">Height</div>
                            <div className="text-sm mt-1 text-[#1A1A1A]">
                                {BILLING.height}
                            </div>
                        </div>
                        <div>
                            <div className="eyebrow">Voice</div>
                            <div className="text-sm mt-1 text-[#1A1A1A]">
                                {BILLING.voice}
                            </div>
                        </div>
                        <div>
                            <div className="eyebrow">Based</div>
                            <div className="text-sm mt-1 text-[#1A1A1A]">
                                {BILLING.location}
                            </div>
                        </div>
                        <div>
                            <div className="eyebrow">Contact</div>
                            <a
                                href={`mailto:${BILLING.email}`}
                                data-testid="hero-email-link"
                                className="text-sm mt-1 text-[#1A1A1A] link-underline block"
                            >
                                {BILLING.email}
                            </a>
                        </div>
                    </motion.div>
                </div>

                {/* Photo column */}
                <div className="col-span-12 md:col-span-6 md:order-2 order-1">
                    <motion.div
                        initial={{ opacity: 0, scale: 1.04 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 1.1 }}
                        className="relative w-full grain"
                    >
                        <div className="aspect-[4/5] w-full overflow-hidden bg-[#EBE9E4]">
                            <img
                                src={HERO_IMAGE}
                                alt="Vickie Daignault"
                                data-testid="hero-image"
                                className="w-full h-full object-cover"
                                loading="eager"
                            />
                        </div>
                        <div className="absolute -left-3 top-6 hidden md:block">
                            <span className="font-sans-ui text-[#1A1A1A] text-xs md:text-sm font-medium tracking-[0.32em] uppercase rotate-180 [writing-mode:vertical-rl]">
                                Vol. I &nbsp;·&nbsp; Portfolio 2026
                            </span>
                        </div>
                    </motion.div>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-6 md:px-12 mt-16 md:mt-20 flex items-center gap-3 text-[#4A4A4A]">
                <ArrowDown size={16} className="animate-bounce" />
                <span className="eyebrow">Scroll</span>
            </div>
        </section>
    );
}
